// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"8":"f03690f6","166":"fcbafd6c","256":"f03690f6","318":"ae42b1d8","531":"d5abd26a","544":"1c3986ab","658":"f03690f6","757":"455f1500","880":"cab2813e","984":"ef521d8e"}[chunkId] + ".chunk.css";
};